<template>
  <div id="banner" class="banner">
    <img src="@/assets/banner-2021.png" alt="國立政治大學校務研究辦公室" />
    <div class="intro" :class="{'sticky': sticky}">
      <h1>{{ title }}</h1>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title","sticky"],
};
</script>

<style scoped>
.banner {
    background-color: var(--bgBlue);
    padding-top: 100px;
}

.banner img {
    width: 100%;
}

.intro {
    padding-top: 20px;
    padding-left: 20%;
    padding-right: 10%;
    padding-bottom: 12px;
}

.intro h1 {
    display: inline-block;
    color: var(--black);
    letter-spacing: 3px;
    margin-left: 16px;
    margin-right: 8px;
    margin-bottom: 12px;
}

.intro h1 {
    font-size: 32px;
    font-weight: 500;
}

.banner .sticky {
  background-color: var(--bgBlue);
  position: fixed;
  top: 80px;
  width: 100%;
  padding-left: 10%;
  padding-right: 5%;
}


@media screen and (max-width: 576px) {
  .intro {
      padding: 8px 8px 24px 8px;
  }
}
</style>
